import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const ApiKey = z.object({
    apiKey: z.string(),
});

export type ApiKey = z.infer<typeof ApiKey>;
